// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"962":"dfdbeeab","1094":"dfdbeeab","2525":"e1a59408","4972":"dfdbeeab","5834":"6ec6a095","6342":"70fc0f3c","6763":"4b593391","7469":"b35f5063","8303":"bbf64ad1"}[chunkId] + ".chunk.css";
};